import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { IconContext } from "react-icons";
import { FiPlus } from "react-icons/fi";
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import api from '../api';
import tConvert from '../utils/TConvert'
import headers from '../utils/headers'

const PersonalSessions = () => {
    const [loading, setLoading] = useState(true);
    const [sessions, setSessions] = useState();

    const reqPersonalSessions = async (role) => {
        const url = (role === 'admin') ? api + '/ptsessions?_sort=created_at:desc' : api + '/ptsessions?_sort=created_at:desc&status=approved&trainer.user=' + localStorage.getItem('id');
        try {
            const {data} = await axios.get(url, {headers});
            setSessions(data);
            setLoading(false);
        } catch (err) {
            console.log(err.response);
        }
    }

    useEffect(() => {
        reqPersonalSessions(localStorage.getItem('type'));
    }, []);

    const StatusColor = (status) => {
        if(status === 'pending'){
            return '#c7c73f';
        } else if(status === 'cancelled'){
            return 'red';
        } else {
            return 'green';
        }
    }

    if(loading){
        return 'Loading...';
    }
    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col>
                        <div className="employee-title">
                            <h3 className="dash-title">Personal Training Sessions</h3>
                            {(localStorage.getItem('type') === 'admin') ? (
                                <Link className="employee-add-btn" to="/personal-session/add">
                                <IconContext.Provider value={{size: '18px', color: "#fff"}}>
                                    <FiPlus />
                                </IconContext.Provider>
                                    Add New
                                </Link>
                            ) : ''}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="container-fluid dashboard-wrapper white-wrapper daily-activity-table">
                <Row>
                    <Table responsive hover>
                        <thead>
                            <tr>
                            <th>Client</th>
                            <th>Preferred Time</th>
                            <th>Confirmed Time</th>
                            <th>Session Type</th>
                            <th>Preffered Trainer</th>
                            <th>Status</th>
                            {/* <th className="activity-button-col">Actions</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {sessions.map(session => (
                                <tr key={session.id}>
                                    <td>
                                        <div className="wh-profile">
                                            <div className="wh-caption">
                                                <p>
                                                    {session.member.name}<br/>
                                                    <small>{session.member.erpid}</small>
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td><Moment format="Do MMMM">{session.date}</Moment> <br/> <small>({session.start_time ? tConvert(session.start_time) : 'N/A'} - {session.end_time ? tConvert(session.end_time) : 'N/A'})</small></td>
                                    <td><Moment format="Do MMMM">{session.date}</Moment></td>
                                    <td style={{textTransform: 'capitalize'}}>{session.session_type}</td>
                                    <td>{session.trainer.name} <br/> <small>{session.trainer.phone}</small></td>
                                    <td>
                                        <span style={{color: StatusColor(session.status), textTransform: 'capitalize'}}>{session.status}</span>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </Table>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default PersonalSessions
